import { NoDataIllustration } from '@/components/illustrations/NoData';

interface NoDataMessageProps {
	title: string;
	description: string;
}

export const NoDataMessage = ({ title, description }: NoDataMessageProps) => {
	return (
		<div className="relative flex min-h-[35vh] w-full max-w-screen-xl flex-col items-center p-8  px-4 pt-4 sm:min-h-[32vh] lg:pt-0">
			<NoDataIllustration className="w-full max-w-[200px] md:max-w-[400px] lg:max-w-[500px] h-auto" />
			<h2 className="mb-3 mt-10 text-xl font-semibold text-gray-900 sm:text-3xl">{title}</h2>
			<p className="text-center font-medium text-gray-700">{description}</p>
		</div>
	);
};
